import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  addButton: {
    marginTop: 4,
    marginLeft: 4,
  },
  removeButton: {
    marginTop: -3,
    marginLeft: 2,
  },
  eanRow: {
    marginTop: 5,
    marginLeft: 2,
    fontSize: 'larger',
  },
}));

export default useStyles;
